import React from "react";
import { Button, Card, Empty, Tag, Typography } from "@douyinfe/semi-ui";
import { AiCoachAdjustment } from "../../../api/aiCoach";
import { radius, sp } from "../styles";

const { Title, Paragraph, Text } = Typography;

interface Props {
  adjustments: AiCoachAdjustment[];
  /** 已经被接受为行动的 adjustmentIndex 集合，对应按钮变禁用态 */
  acceptedIndexes?: number[];
  onAccept: (idx: number) => void;
}

const AdjustmentCards: React.FC<Props> = ({ adjustments, acceptedIndexes, onAccept }) => (
  <Card
    style={{ marginBottom: sp.lg, borderRadius: radius.md }}
    bodyStyle={{ padding: sp.lg }}
  >
    <Title heading={5} style={{ margin: `0 0 ${sp.md}` }}>
      调整建议
    </Title>

    {adjustments.length === 0 ? (
      <Empty description="本周暂无调整建议" />
    ) : (
      <div style={{ display: "flex", flexDirection: "column", gap: sp.md }}>
        {adjustments.map((a, i) => {
          const accepted = acceptedIndexes?.includes(i);
          return (
          <div
            key={i}
            style={{
              padding: sp.lg,
              background: "var(--semi-color-bg-1)",
              border: "1px solid var(--semi-color-border)",
              borderRadius: radius.md,
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "flex-start",
                gap: sp.sm,
                marginBottom: sp.sm,
              }}
            >
              <Tag
                color={accepted ? "green" : "blue"}
                size="large"
                style={{
                  minWidth: 28,
                  textAlign: "center",
                  borderRadius: "50%",
                }}
              >
                {i + 1}
              </Tag>
              <Text strong style={{ fontSize: 16, flex: 1, lineHeight: "28px" }}>
                {a.title}
              </Text>
              {accepted ? (
                <Button size="small" disabled>
                  ✓ 已接受
                </Button>
              ) : (
                <Button
                  theme="solid"
                  type="primary"
                  size="small"
                  onClick={() => onAccept(i)}
                >
                  接受为行动
                </Button>
              )}
            </div>

            <Paragraph style={{ margin: `0 0 ${sp.md}`, lineHeight: 1.8, paddingLeft: 40 }}>
              {a.action}
            </Paragraph>

            {a.weeklyGoal && (
              <div
                style={{
                  marginLeft: 40,
                  padding: `${sp.xs} ${sp.md}`,
                  background: "var(--semi-color-warning-light-default)",
                  borderRadius: radius.sm,
                  display: "inline-block",
                }}
              >
                <Text strong style={{ color: "var(--semi-color-warning)" }}>
                  🎯 本周目标：
                </Text>
                <Text> {a.weeklyGoal}</Text>
              </div>
            )}
          </div>
          );
        })}
      </div>
    )}
  </Card>
);

export default AdjustmentCards;
